'use client';

import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { useLayoutEffect, useState } from 'react';
import style from '../HeaderButtons.module.scss';
export const useHeaderColorScheme = headerColorScheme => {
  const $ = _c(3);
  const [headerBtnStyle, setHeaderBtnStyle] = useState(style.headerBar__button);
  let t0;
  let t1;
  if ($[0] !== headerColorScheme) {
    t0 = () => {
      if (headerColorScheme === "" || headerColorScheme === "blackOnTransparent") {
        setHeaderBtnStyle(classNames(style.headerBar__button, style.headerBarWhite__button));
      } else {
        setHeaderBtnStyle(style.headerBar__button);
      }
    };
    t1 = [headerColorScheme];
    $[0] = headerColorScheme;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useLayoutEffect(t0, t1);
  return headerBtnStyle;
};